import { StateManager } from '../../managers/StateManager';
import { Connector as ConnectorData } from '../../types';
import { ContextMenuHandlers } from './types';
import { ContextMenuItem } from './wireMenu';

/** Dependencies the connector menu needs to read state and drive React modals/menus. */
export interface ConnectorMenuDeps {
  stateManager: StateManager;
  contextMenuHandlers: ContextMenuHandlers;
}

/**
 * Opens a follow-up context menu listing the connector-type catalog; applying a
 * type instantiates its pins on the connector.
 */
function showTypePicker(deps: ConnectorMenuDeps, connectorId: string, x: number, y: number): void {
  const { stateManager, contextMenuHandlers } = deps;
  const types = stateManager.getState().connectorTypes;

  if (types.length === 0) {
    contextMenuHandlers.showContextMenu(x, y, [
      { label: 'No types - add some in Connector Types', action: () => {} }
    ]);
    return;
  }

  contextMenuHandlers.showContextMenu(
    x,
    y,
    types.map(type => ({
      label: `${type.name} (${type.pins.length} pins)`,
      action: () => contextMenuHandlers.handleApplyConnectorType(connectorId, type.id)
    }))
  );
}

/**
 * Builds the context-menu entries for a connector: rename, edit or apply pins,
 * and delete. Shared so the canvas right-click menu offers them wherever the
 * click lands on a connector card outside a wire row.
 */
export function buildConnectorContextMenu(
  deps: ConnectorMenuDeps,
  connector: ConnectorData,
  x: number,
  y: number
): ContextMenuItem[] {
  const { contextMenuHandlers } = deps;
  return [
    {
      label: 'Rename Connector',
      action: () => contextMenuHandlers.handleConnectorRename(connector.id, connector.name)
    },
    {
      label: 'Edit Pins',
      action: () => contextMenuHandlers.handleConnectorEditPins(connector.id)
    },
    {
      label: 'Apply Type',
      action: () => showTypePicker(deps, connector.id, x, y),
      closeOnClick: false
    },
    {
      label: 'Delete Connector',
      action: () => contextMenuHandlers.handleConnectorDelete(connector.id),
      dangerous: true
    }
  ];
}
